import themeConfigs from "~~/app/themes";
type ThemeName = keyof typeof themeConfigs;
import { updateAppConfig, useAppConfig } from "#imports";
import { defu } from "defu";

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();

  const themeName = runtimeConfig.public.theme as ThemeName;

  // const colorMode = useColorMode();

  // const theme = themeConfigs[themeName];

  // const appConfig = useAppConfig();

  // const newAppConfig = defu(theme[colorMode.value], { ...appConfig });

  document.documentElement.classList.add(themeName);

  // updateAppConfig(newAppConfig);

  // return {
  //   provide: {
  //     theme,
  //   },
  // };
});
